import { jsx } from "@emotion/react"

// Builds a component that translates between PortableText serializer
// props and typical React component props.
const buildSerializer =
  (Component, { propMap, ...initialProps } = {}) =>
  ({ node }) =>
    jsx(
      Component,
      propMap
        ? Object.entries(node).reduce((props, [prop, value]) => {
            if (Object.prototype.hasOwnProperty.call(propMap, prop)) {
              props[propMap[prop]] = value
            } else {
              props[prop] = value
            }
            return props
          }, initialProps)
        : { ...initialProps, ...node }
    )

export default buildSerializer
